export enum StatusQuoteSupplierItem {
  Pending = 1,
  Answered = 2,
  NotQuoted = 3
}

